import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import PageWrapper from "../SignupPages/PageWrapper";
import "../SignupPages/SignupCommon.css";
import CustomStepper from "./Stepper";

const NewSignupPage5: React.FC = () => {
  const [selectedOption, setSelectedOption] = useState<string>("");
  const navigate = useNavigate();
  const location = useLocation(); // ✅

  // ✅ Safe navigate to prevent redundant GTM replaceState
  const safeNavigate = (path: string) => {
    if (location.pathname !== path) {
      navigate(path, { replace: true });
    }
  };

  useEffect(() => {
    const step4Completed = localStorage.getItem("step-4-completed");
    if (step4Completed) {
      safeNavigate("/getting-started/step-5");
    } else {
      safeNavigate("/getting-started/step-4");
    }
  }, []);

  const handleOptionClick = (option: string) => {
    setSelectedOption(option);
  };
  const handleBack = () => {
    navigate("/getting-started/step-4")
      }

  const handleNext = () => {
    if (selectedOption) {
      localStorage.setItem(
        "weight_loss_medication",
        JSON.stringify({
          key: "weight_loss_medication",
          value: selectedOption,
        })
      );
    }
    navigate("/getting-started/step-6");
    localStorage.setItem("step-5-completed", "true");
  };

  useEffect(() => {
    const savedWeightLoss = localStorage.getItem("weight_loss_medication");

    if (savedWeightLoss) {
      const parsedWeightLoss = JSON.parse(savedWeightLoss);
      setSelectedOption(parsedWeightLoss.value);
    }
  }, []);

  const options = [
   "Yes",
   "No"
  ];


  return (
    <PageWrapper onBack={handleBack}>
      <div className="signup-page-container container">
        <CustomStepper activeStep={1} onBack={handleBack}/>
        <div className="signup-content">
          <p className="signup-content-header">
          Are you currently taking or have recently (within the last 12 months) taken medication (GLP-1 or non-GLP1) for weight loss?
          </p>
          <div className="options options-box-contents">
            {options.map((option) => (
              <label
                key={option}
                className={selectedOption === option ? "selected" : ""}
                onClick={() => handleOptionClick(option)}
              >
                {option}
              </label>
            ))}
          </div>
          <button 
            className="next-btn sticky-btn"
            onClick={handleNext}
            disabled={!selectedOption}
            >
             Continue →
          </button>
        </div>
      </div>
    </PageWrapper>
  );
};

export default NewSignupPage5;